import { useEcommerceOrdersService } from '@/views/Orders/EcommerceOrders/services/ecommerceOrdersService'

export function createEcommerceOrdersActions(state) {
    const ecommerceOrdersService = useEcommerceOrdersService()

    const fetchOrders = async (queryString = '') => {
        try {
            state.ordersLoading.value = true
            const response = await ecommerceOrdersService.fetchOrders(queryString)
            state.orders.value = response.data.results || []
            return response
        } catch (error) {
            throw error
        } finally {
            state.ordersLoading.value = false
        }
    }

    const fetchOrder = async (orderId) => {
        try {
            state.ordersLoading.value = true
            const response = await ecommerceOrdersService.fetchOrder(orderId)
            state.order.value = response.data
            return response
        } catch (error) {
            throw error
        } finally {
            state.ordersLoading.value = false
        }
    }

    const fetchOrderStatuses = async () => {
        try {
            const response = await ecommerceOrdersService.fetchOrderStatuses()
            state.orderStatusList.value = response.data.results || []
            return response
        } catch (error) {
            throw error
        }
    }

    const fetchCountries = async () => {
        try {
            const response = await ecommerceOrdersService.fetchCountries()
            state.countries.value = response.data.results || []
            return response
        } catch (error) {
            throw error
        }
    }

    const fetchPrinters = async () => {
        try {
            const response = await ecommerceOrdersService.fetchPrinters()
            state.printers.value = response.data.results || []
            return response
        } catch (error) {
            throw error
        }
    }

    const updateOrder = async (orderData) => {
        try {
            state.ordersLoading.value = true
            return await ecommerceOrdersService.updateOrder(orderData)
        } catch (error) {
            throw error
        } finally {
            state.ordersLoading.value = false
        }
    }

    const addComment = async (commentData) => {
        try {
            return await ecommerceOrdersService.addComment(commentData)
        } catch (error) {
            throw error
        }
    }

    const updateDelivery = async (deliveryId, payload) => {
        try {
            return await ecommerceOrdersService.updateDelivery(deliveryId, payload)
        } catch (error) {
            throw error
        }
    }

    const fetchToolboxTemplateContent = async (toolboxURI, templateId) => {
        try {
            return await ecommerceOrdersService.fetchToolboxTemplateContent(toolboxURI, templateId)
        } catch (error) {
            throw error
        }
    }

    const setFilters = (filters) => {
        state.filters.value = { ...state.filters.value, ...filters }
    }

    const resetFilters = () => {
        state.filters.value = state.createInitialFilters()
    }

    const printZPL = async (payload) => {
        try {
            return await ecommerceOrdersService.printZPL(payload)
        } catch (error) {
            throw error
        }
    }

    return {
        fetchOrders,
        fetchOrder,
        fetchOrderStatuses,
        fetchCountries,
        fetchPrinters,
        updateOrder,
        addComment,
        updateDelivery,
        fetchToolboxTemplateContent,
        printZPL,
        setFilters,
        resetFilters
    }
}
